/* eslint-disable max-lines */
/* eslint-disable camelcase */
import { FiltersTreeContext } from 'contexts/ExploreFiltersTreeContext';
import React, { useContext } from 'react';
import { Tag } from 'types';

type ResourceFilterProps = {
  tag: Tag & { count?: number };
  handleInputChange: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    exclude: boolean,
    state: string,
    checked: string | undefined,
    isTag: boolean
  ) => void;
  treeContext: React.Context<FiltersTreeContext>;
};

const TagFilterItem: React.FC<ResourceFilterProps> = (props) => {
  const { tag, handleInputChange, treeContext } = props;
  const { treeParams } = useContext(treeContext);

  const tagsKey = 'tags';

  const filterTagsItems = (treeParams[tagsKey] ?? []) as string[];
  const notFilterTagsItems = (treeParams[`not_${tagsKey}`] ?? []) as string[];

  const allTagsFilterItems = [...filterTagsItems, ...notFilterTagsItems];

  const handleTagChange = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    const { shiftKey: exclude } = event.nativeEvent;
    const { id: state } = event.currentTarget;

    const checked = event.currentTarget.dataset.checked === 'true' ? 'false' : 'true';

    handleInputChange(event, exclude, state, checked, true);
  };

  return (
    <>
      <div
        id={tag.uuid}
        role="button"
        aria-hidden
        className="w-full py-1 px-2 relative flex flex-row gap-1 items-start cursor-pointer"
        data-checked={allTagsFilterItems.includes(tag.uuid)}
        onClick={(e): void => handleTagChange(e)}
      >
        <div className="w-full relative flex flex-col items-start justify-center text-small cursor-pointer">
          <div className="w-full relative flex flex-row gap-1 justify-start items-start">
            <input
              id={tag.uuid}
              data-testid={`${tag.uuid}-checkbox`}
              type="checkbox"
              className={`form-checkbox litlingo-checkbox h-4 w-4 transition duration-150 ease-in-out cursor-pointer 
              
              ${
                notFilterTagsItems.includes(tag.uuid)
                  ? 'litlingo-checkbox-negated'
                  : 'litlingo-checkbox'
              }`}
              checked={allTagsFilterItems.includes(tag.uuid)}
            />

            <label
              htmlFor={tag.uuid}
              className="w-full flex flex-row justify-between gap-1 text-small cursor-pointer"
            >
              <span
                className="w-full select-none font-semibold"
                style={{ wordBreak: 'break-word' }}
              >
                {tag.value}
              </span>
              <span className="text-litlingo-primary">
                {!tag.count && tag.count !== 0 ? '-' : tag.count}
              </span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default TagFilterItem;
